import type { IProjectLoader, ProjectFile, ProjectLoadResult } from '@repo/project-interface';
import { DefaultProjectSerializer } from '@repo/project-serializer/impl';

/**
 * pjt file url로 부터 프로젝트를 로드한다.
 * pjt file의 헤더에 projectId, accountId 정보가 있다
 */
export class PjtFileUrlLoader implements IProjectLoader<ProjectFile[]> {
  #url: string;
  #removeProjectKey: boolean;

  /**
   * 시스템에서 제공하는 템플릿 프로젝트의 경우 removeProjectKey=true로 설정하세요.
   *
   * @param url - pjt file url
   * @param removeProjectKey - true이면 projectKey를 제거한다.
   */
  constructor(url: string, removeProjectKey: boolean) {
    this.#url = url;
    this.#removeProjectKey = removeProjectKey;
  }

  async load(signal?: AbortSignal): Promise<ProjectLoadResult<ProjectFile[]>> {
    const pjtFile = await fetch(this.#url, { signal }).then((res) => res.blob());
    const { meta, data } = await DefaultProjectSerializer.deserializePjtFile(pjtFile);

    return {
      breed: meta.breed,
      project: this.#removeProjectKey ? undefined : meta.project,
      projectName: meta.projectName,
      data,
    };
  }
}
